import React from 'react';
import { MobileCard } from './MobileCard';
import { ActionButton, MobileActionButton } from './ActionButtons';
import { TableSkeleton } from './TableSkeleton';
import { DefaultEmptyState } from './EmptyState';

export const ResponsiveTable = ({ 
  data = [], 
  columns = [], 
  actions = [],
  emptyState,
  className = "",
  onRowClick,
  loading = false
}) => {
  if (loading) {
    return <TableSkeleton />;
  }

  if (data.length === 0) {
    return emptyState || <DefaultEmptyState />;
  }

  return (
    <>
      {/* Desktop Table View */}
      <div className={`hidden lg:block overflow-x-auto rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm ${className}`}>
        <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
          <thead className="bg-gray-50 dark:bg-gray-800">
            <tr>
              {columns.map((column) => (
                <th
                  key={column.key}
                  className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider"
                  style={{ width: column.width }}
                >
                  {column.header}
                </th>
              ))}
              {actions.length > 0 && (
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
                  Actions
                </th>
              )}
            </tr>
          </thead>
          <tbody className="bg-white dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-700">
            {data.map((item, index) => (
              <tr
                key={item.id || index}
                className={`hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors duration-200 ${
                  onRowClick ? 'cursor-pointer' : ''
                }`}
                onClick={() => onRowClick?.(item)}
              >
                {columns.map((column) => (
                  <td key={column.key} className="px-6 py-4 whitespace-nowrap">
                    {column.render ? column.render(item[column.key], item) : (
                      <span className={`text-sm ${column.className || 'text-gray-700 dark:text-gray-300'}`}>
                        {typeof item[column.key] === 'object' && item[column.key] !== null
                          ? JSON.stringify(item[column.key])
                          : item[column.key]
                        }
                      </span>
                    )}
                  </td>
                ))}
                {actions.length > 0 && (
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                    <div className="flex items-center space-x-3">
                      {actions.map((action, actionIndex) => (
                        <ActionButton
                          key={actionIndex}
                          action={action}
                          item={item}
                        />
                      ))}
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile/Tablet Card View */}
      <div className="lg:hidden space-y-4">
        {data.map((item, index) => (
          <div
            key={item.id || index}
            className={`bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm hover:shadow-md transition-shadow duration-200 p-6 ${
              onRowClick ? 'cursor-pointer' : ''
            }`}
            onClick={() => onRowClick?.(item)}
          >
            <MobileCard item={item} columns={columns} actions={actions} />
          </div>
        ))}
      </div>
    </>
  );
};